import SecuritizePage from './SecuritizePage';

export default SecuritizePage;
